import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { map, tap } from 'rxjs/operators';
import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, WBotanicaExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { EnumIdsTcEstadoSolicitud } from '../../../_importacion/solicitudes/types/enum';
import { InformesService } from '../informes.service';
import {
    EnumIdsInformeInspeccionesAgrupacionFechas,
    FilterSearchingInformeInspeccionesViewModel,
    InformeInspeccionesItemResultsViewModel,
} from '../informes.types';

@Component({
    selector: 'app-informe-inspecciones',
    templateUrl: './informe-inspecciones.component.html',
})
export class InformeInspeccionesComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    @ViewChild(EspecieEppoPopupComponent) private especieEppoPopupComponent: EspecieEppoPopupComponent;

    resultInformeInspecciones: InformeInspeccionesItemResultsViewModel;

    listPuntosInspeccion: Tc[];
    listPaisOrigen: Tc[];
    listPaisProcedencia: Tc[];
    listGruposPaisesFr: Tc[];
    listTipoSolicitud: Tc[];
    listEstado: Tc[];
    listProvincias: Tc[];
    listDecision: Tc[];
    listMedidas: Tc[];
    listMotivos: Tc[];

    listGrupo: Tc[];
    listForma: Tc[];
    listSubForma: Tc[];

    //combos para CodigoEppo. Sólo el Grupo es obligatorio
    IdGrupo: number | null = null;
    IdForma: number | null = null;
    IdSubForma: number | null = null;

    //filteredCodigoTaric$: Observable<string>;
    filteredCodigoTaric: Tc[];
    CodigoTaric = '';
    resultsCodigoTaric: Tc[];

    listAgrupacionFechas: SelectItem[];
    listCodigoEppo: Tc[] = [];
    listCriterioBusquedaProductos: SelectItem[];

    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];

    IdAgrupacionFechasDescripcion = 'Sin agrupar';
    OrderBy = 'FechaEnvio';
    OrderAsc = 0;

    //campos para guardar las descripciones de los combos. Se pasarán al modelo al realizar la búsqueda
    IdTipoSolicitudDescripcion = '';
    IdEstadoSolicitudDescripcion = '';
    IdProvinciaDescripcion = '';
    IdPuntoInspeccionDescripcion = '';
    IdPaisOrigenDescripcion = '';
    IdPaisOrigenGrupoPaisFrDescripcion = '';
    IdPaisProcedenciaDescripcion = '';
    IdPaisProcedenciaGrupoPaisFrDescripcion = '';
    IdDecisionDescripcion = '';
    IdMotivoDescripcion = '';
    IdMedidaDescripcion = '';

    IdGrupoDescripcion = '';
    IdFormaDescripcion = '';
    IdSubFormaDescripcion = '';
    CodigoEppoDescripcionCollection: string[] = [];

    habilitarBusquedaEppo = false;

    campoObligatorio = false;
    visibilitySpinner = false;
    loadingPIFs = false;
    loadingForma = false;
    loadingSubforma = false;

    public isCollapsedGlobal = false;
    public isCollapsedDatosSolicitud = false;
    public isCollapsedLocalizacion = false;
    public isCollapsedPaisOrigen = false;
    public isCollapsedPaisProcedencia = false;
    public isCollapsedProductos = false;
    public isCollapsedBusquedaCodigoEppo = false;
    public isCollapsedBusquedaCodigoTaric = false;
    public isCollapsedInspeccion = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private informesService: InformesService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultInformeInspecciones = new InformeInspeccionesItemResultsViewModel();
    }

    ngOnInit() {
        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        //p-selectButton
        this.listAgrupacionFechas = [
            { label: 'Sin agrupar', value: EnumIdsInformeInspeccionesAgrupacionFechas.ID_SIN_AGRUPAR },
            { label: 'Mes', value: EnumIdsInformeInspeccionesAgrupacionFechas.ID_MES },
            { label: 'Año', value: EnumIdsInformeInspeccionesAgrupacionFechas.ID_ANIO },
        ];

        this.asignarColumnasGrid(EnumIdsInformeInspeccionesAgrupacionFechas.ID_SIN_AGRUPAR);

        this.globalService.getAllPaises().subscribe(res => {
            this.listPaisOrigen = res;
            this.listPaisProcedencia = res;
        });
        this.globalService.getGrupoPaisesFr().subscribe(res => {
            this.listGruposPaisesFr = res;
        });

        this.globalService.getTipoSolicitud().subscribe(res => {
            this.listTipoSolicitud = res;
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });
        this.globalService
            .getEstadoSolicitud()
            .pipe(
                map(r => r.filter(o => o.Id == EnumIdsTcEstadoSolicitud.ID_FINALIZADA_CONFORME || o.Id == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_INSPECTOR)),
                tap(res => {
                    this.listEstado = res;
                }),
            )
            .subscribe();

        this.informesService.getDecisionInspeccion().subscribe(res => {
            this.listDecision = res;
        });
        this.globalService.getMedidasRechazo().subscribe(res => {
            this.listMedidas = res;
        });
        this.globalService.getMotivosRechazo().subscribe(res => {
            this.listMotivos = res;
        });

        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });

        this.listCriterioBusquedaProductos = [
            { label: 'Código EPPO', value: 'EPPO' },
            { label: 'Código TARIC', value: 'TARIC' },
        ];

        this.form = this.fb.group({
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdAgrupacionFechas: EnumIdsInformeInspeccionesAgrupacionFechas.ID_SIN_AGRUPAR,
            IdTipoSolicitud: null,
            IdEstadoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            IdPaisOrigen: null,
            IdPaisOrigenGrupoPaisFr: null,
            IdPaisProcedencia: null,
            IdPaisProcedenciaGrupoPaisFr: null,
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            IdCriterioBusquedaProductos: 'EPPO',
            CodigoTaric: [null, Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(2)])],
            CodigoEppo: null,
            IdDecision: null,
            IdMotivo: null,
            IdMedida: null,
        });

        this.form.controls['IdPuntoInspeccion'].disable();

        //al cargar la pantalla, por defecto, búsqueda por Código Eppo
        this.onSelectCriterioBusquedaProductos();
        //obtención de la descripción de esta selección, siempre viaja aunque no haya ningún otro filtro relleno
        //this.onSelectAgrupacionFechas(EnumIdsInformeImportacionesAgrupacionFechas.ID_SIN_AGRUPAR);
    }

    asignarColumnasGrid(agrupacion: EnumIdsInformeInspeccionesAgrupacionFechas): void {
        switch (agrupacion) {
            case EnumIdsInformeInspeccionesAgrupacionFechas.ID_SIN_AGRUPAR:
                this.cols = [
                    { field: 'Link', header: '' },
                    { field: 'IdSolicitud', header: 'IdSolicitud', display: 'none' },
                    { field: 'Image', header: '' },
                    { field: 'Codigo', header: 'Nº Solicitud' },
                    { field: 'FechaEnvio', header: 'Fecha Envío' },
                    { field: 'Provincia', header: 'Provincia' },
                    { field: 'PuntoInspeccion', header: 'Punto Inspección' },
                    { field: 'CodigoTaric', header: 'Código Taric' },
                    { field: 'CodigoEppo', header: 'Código Eppo' },
                    { field: 'Grupo', header: 'Grupo' },
                    { field: 'Forma', header: 'Forma' },
                    { field: 'NombreCientifico', header: 'Nombre Botánico' },
                    { field: 'PaisOrigen', header: 'País Origen' },
                    { field: 'PaisProcedencia', header: 'País Procedencia' },
                    { field: 'Matriculas', header: 'Nº Matrí­culas/Contenedor' },
                    { field: 'NombreInspector', header: 'Nombre Inspector' },
                    { field: 'Documental', header: 'Inspección Documental' },
                    { field: 'FechaDocumental', header: 'Fecha y Hora Inspecc. Docum.' },
                    { field: 'Identidad', header: 'Inspección Identidad' },
                    { field: 'FechaIdentidad', header: 'Fecha y Hora Inspecc. Ident.' },
                    { field: 'Fisica', header: 'Inspección Física' },
                    { field: 'FechaFisica', header: 'Fecha y Hora Inspecc. Física' },
                    { field: 'Decision', header: 'Decisión Final' },
                    { field: 'FechaFinalizacion', header: 'Fecha y Hora Decisión Final' },
                    { field: 'Medidas', header: 'Medidas' },
                ];

                break;

            case EnumIdsInformeInspeccionesAgrupacionFechas.ID_ANIO:
                this.cols = [
                    { field: 'Link', header: '' },
                    //{ field: 'Id', header: 'Id', display: 'none' },
                    { field: 'Image', header: '' },
                    { field: 'CuentaSolicitudes', header: 'Nº Solicitudes' },
                    { field: 'Año', header: 'AÑO' },
                    { field: 'Provincia', header: 'Provincia' },
                    { field: 'PuntoInspeccion', header: 'Punto Inspección' },
                    { field: 'CodigoTaric', header: 'Código Taric' },
                    { field: 'CodigoEppo', header: 'Código Eppo' },
                    { field: 'Grupo', header: 'Grupo' },
                    { field: 'Forma', header: 'Forma' },
                    { field: 'NombreCientifico', header: 'Nombre Botánico' },
                    { field: 'PaisOrigen', header: 'País Origen' },
                ];

                break;

            case EnumIdsInformeInspeccionesAgrupacionFechas.ID_MES:
                this.cols = [
                    { field: 'Link', header: '' },
                    //{ field: 'Id', header: 'Id', display: 'none' },
                    { field: 'Image', header: '' },
                    { field: 'CuentaSolicitudes', header: 'Nº Solicitudes' },
                    { field: 'Mes', header: 'MES' },
                    { field: 'Año', header: 'AÑO' },
                    { field: 'Provincia', header: 'Provincia' },
                    { field: 'PuntoInspeccion', header: 'Punto Inspección' },
                    { field: 'CodigoTaric', header: 'Código Taric' },
                    { field: 'CodigoEppo', header: 'Código Eppo' },
                    { field: 'Grupo', header: 'Grupo' },
                    { field: 'Forma', header: 'Forma' },
                    { field: 'NombreCientifico', header: 'Nombre Botánico' },
                    { field: 'PaisOrigen', header: 'País Origen' },
                ];

                break;
        }
    }

    //entra aquí­ cada vez que pulsa una tecla. Pero no entra cuando se selecciona un elemento del combo
    filterCodigoTaric(event: any): void {
        this.CodigoTaric = event.query;

        this.informesService.search(event.query).subscribe(res => {
            this.resultsCodigoTaric = res;
        });
    }

    //entra aquí­ cuando selecciona un elemento del combo. Viene como { Id: 0000, Descripcion: "xxxx" } por el template del html
    onSelectCodigoTaric(event: any): void {
        this.CodigoTaric = event.value.Id;
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed(true);
    }

    CreateModel(): FilterSearchingInformeInspeccionesViewModel {
        let model: FilterSearchingInformeInspeccionesViewModel = new FilterSearchingInformeInspeccionesViewModel();

        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta;
        model.IdAgrupacionFechas = this.form.value.IdAgrupacionFechas;
        model.IdAgrupacionFechasDescripcion = this.IdAgrupacionFechasDescripcion;
        model.IdTipoSolicitud = this.form.value.IdTipoSolicitud;
        model.IdTipoSolicitudDescripcion = this.IdTipoSolicitudDescripcion;
        model.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        model.IdEstadoSolicitudDescripcion = this.form.value.IdEstadoSolicitudDescripcion;
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdProvinciaDescripcion = this.IdProvinciaDescripcion;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.IdPuntoInspeccionDescripcion = this.IdPuntoInspeccionDescripcion;
        model.IdPaisOrigen = this.form.value.IdPaisOrigen;
        model.IdPaisOrigenDescripcion = this.IdPaisOrigenDescripcion;
        model.IdPaisOrigenGrupoPaisFr = this.form.value.IdPaisOrigenGrupoPaisFr;
        model.IdPaisOrigenGrupoPaisFrDescripcion = this.IdPaisOrigenGrupoPaisFrDescripcion;
        model.IdPaisProcedenciaCollection = this.form.value.IdPaisProcedencia;
        model.IdPaisProcedenciaDescripcion = this.IdPaisProcedenciaDescripcion;
        model.IdPaisProcedenciaGrupoPaisFrCollection = this.form.value.IdPaisProcedenciaGrupoPaisFr;
        model.IdPaisProcedenciaGrupoPaisFrDescripcion = this.IdPaisProcedenciaGrupoPaisFrDescripcion;
        model.IdGrupo = this.form.value.IdGrupo;
        model.IdGrupoDescripcion = this.IdGrupoDescripcion;
        model.IdForma = this.form.value.IdForma;
        model.IdFormaDescripcion = this.IdFormaDescripcion;
        model.IdSubForma = this.form.value.IdSubForma;
        model.IdSubFormaDescripcion = this.IdSubFormaDescripcion;
        model.CodigoEppoCollection = this.form.value.CodigoEppo;
        model.CodigoEppoDescripcionCollection = this.CodigoEppoDescripcionCollection;
        model.CodigoTaric = this.CodigoTaric;
        model.IdDecision = this.form.value.IdDecision;
        model.IdDecisionDescripcion = this.IdDecisionDescripcion;
        model.IdMotivo = this.form.value.IdMotivo;
        model.IdMotivoDescripcion = this.IdMotivoDescripcion;
        model.IdMedida = this.form.value.IdMedida;
        model.IdMedidaDescripcion = this.form.value.IdMedidaDescripcion;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaHasta != null) {
            model.FechaHasta.setHours(23);
            model.FechaHasta.setMinutes(59);
            model.FechaHasta.setSeconds(59);
        }

        return model;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let model: FilterSearchingInformeInspeccionesViewModel = this.CreateModel();

        //si llegar el parámetro orderBy relleno es que el usuario ha pulsado en una columna del grid para ordenar por esa columna
        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy == '' ? this.OrderBy : orderBy;

        //se guarda para que en Excel salga ordenado igual
        this.OrderBy = model.OrderBy; //actualizamos por si el usuario decidió ordenar por una columna del grid. Se guarda para el Excel
        this.OrderAsc = asc;

        //visualizar columnas según la agrupación de fechas elegida
        this.asignarColumnasGrid(this.form.value.IdAgrupacionFechas);

        this.informesService.postInformeInspeccionesPagedByFilter(model).subscribe(result => {
            this.resultInformeInspecciones = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onSelectCriterioBusquedaProductos(): void {
        const idCriterioBusquedaProductos = this.form.controls['IdCriterioBusquedaProductos'].value;

        //para Taric porque no tiene sentido y para Eppo porque antes ha de seleccionar un grupo
        this.habilitarBusquedaEppo = false;

        switch (idCriterioBusquedaProductos) {
            case 'TARIC':
                this.removeValidators('CodigoEppo');
                this.campoObligatorio = false;

                this.form.controls['CodigoTaric'].enable();

                this.form.patchValue({
                    IdGrupo: null,
                    IdForma: null,
                    IdSubForma: null,
                    CodigoEppo: '',
                });
                this.form.controls['IdGrupo'].disable();
                this.form.controls['IdForma'].disable();
                this.form.controls['IdSubForma'].disable();
                this.form.controls['CodigoEppo'].disable();

                this.IdGrupoDescripcion = '';
                this.IdFormaDescripcion = '';
                this.IdSubFormaDescripcion = '';
                this.CodigoEppoDescripcionCollection = [];

                this.listCodigoEppo = []; //limpia el origen del combo de Código Eppo
                this.CodigoTaric = ''; //limpia el Código Taric

                //grupo y forma que se le pasa al popup de Código Eppo
                this.IdGrupo = null;
                this.IdForma = null;

                break;

            case 'EPPO':
                this.addValidator('CodigoEppo', Validators.required);
                this.campoObligatorio = true;

                this.form.controls['IdGrupo'].enable();
                this.form.controls['IdForma'].enable();
                this.form.controls['IdSubForma'].enable();
                this.form.controls['CodigoEppo'].enable();

                this.form.patchValue({
                    CodigoTaric: '',
                });
                this.form.controls['CodigoTaric'].disable();

                this.CodigoTaric = ''; //limpia el Código Taric

                break;
            default:
                break;
        }
    }

    onSelectGrupo(event: Tc): void {
        this.IdGrupoDescripcion = '';
        //limpiar descripciones de campos dependientes
        this.IdFormaDescripcion = '';
        this.IdSubFormaDescripcion = '';

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            this.IdGrupoDescripcion = event.Descripcion;

            //actualizar para comunicación con popup Código Eppo
            this.IdGrupo = this.form.value.IdGrupo;
            this.IdForma = null;

            //cargar combos dependientes
            if (this.IdGrupo != null) {
                this.loadingForma = true;
                this.globalService.getFormasByGrupo(this.IdGrupo).subscribe(res => {
                    this.loadingForma = false;
                    this.listForma = res;
                });
                this.habilitarBusquedaEppo = true;
            }
        } else {
            //deshabilitar el botón de buscar Código Eppo, ya que el grupo es necesario tenerlo
            this.habilitarBusquedaEppo = false;

            //limpiar listas que alimentan los combos dependientes
            this.listForma = [];
            this.listSubForma = [];
        }

        this.listCodigoEppo = []; //limpia el origen del combo de Código Eppo

        //resetear selección de combos dependientes de éste
        this.form.patchValue({
            IdForma: null,
            IdSubForma: null,
            CodigoEppo: null,
        });
    }

    onSelectForma(event: Tc): void {
        this.IdFormaDescripcion = '';
        //limpiar descripciones de campos dependientes
        this.IdSubFormaDescripcion = '';

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            this.IdFormaDescripcion = event.Descripcion;

            //actualizar para comunicación con popup Código Eppo
            this.IdForma = this.form.value.IdForma;
            this.IdSubForma = null;

            //cargar combos dependientes
            if (this.IdForma != null) {
                this.loadingSubforma = true;
                this.globalService.getSubFormasByForma(this.IdForma).subscribe(res => {
                    this.loadingSubforma = false;
                    this.listSubForma = res;
                });
            }
        } else {
            //limpiar listas que alimentan los combos dependientes
            this.listSubForma = [];
        }

        this.listCodigoEppo = []; //limpia el origen del combo de Código Eppo

        //resetear selección de combos dependientes de éste
        this.form.patchValue({
            IdSubForma: null,
            CodigoEppo: null,
        });
    }

    //eliminación de un CodigoEppo del combo
    clear(event: Tc): void {
        let index = this.listCodigoEppo.findIndex(item => item.Id == event.Id);

        if (index > -1) {
            this.listCodigoEppo.splice(index, 1);
        }

        //automáticamente quedan seleccionados en el combo de CodigosEppo todos los existentes excepto el eliminado
        //const selectedAll = this.listCodigoEppo.map(x => x.Id);
        const selectedAll = Array.from(this.listCodigoEppo.values());
        this.form.patchValue({
            CodigoEppo: selectedAll,
        });
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.IdGrupo, this.IdForma!, this.form.controls['IdSubForma'].value, true);
    }

    onAcceptDialogEspecieEppo(especiesEppo: WBotanicaExtendedViewModel[]): void {
        //let cadenaEppo: string = '';
        //this.listCodigoEppo = [];
        //let listGeneradaCodigosEppo: Tc[] = [];

        //para enviar las descripciones de Códigos Eppo al servidor
        this.CodigoEppoDescripcionCollection = [];
        //con todos los CodigoEppo seleccionados del popup se crean los datos de origen del combobox de CodigosEppo
        if (especiesEppo != null && especiesEppo.length > 0) {
            this.listCodigoEppo = []; //limpia el origen del combo de Código Eppo

            especiesEppo.forEach(x => {
                //Algún Código Eppo, como ALLCE, se repite para mismo grupo (3) y forma (14) variando sólo el nombre cientí­fico (nombre común chalote o cebolla, por ejemplo).
                //Detectar si no está ya en el combo para su inserción
                if (x.CodigoEppo != null && this.listCodigoEppo.findIndex(w => w.Id == x.IdCodigoEppo) == -1) {
                    //cadenaEppo = cadenaEppo.concat(x.CodigoEppo, ', ');
                    this.listCodigoEppo.push({ Id: x.IdCodigoEppo, Descripcion: x.CodigoEppo });
                    //etiqueta del Código Eppo
                    this.CodigoEppoDescripcionCollection.push(x.CodigoEppo);
                }
            });

            //automáticamente quedan seleccionados en el combo de CodigosEppo todos los seleccionados desde el popup
            const selectedAll = this.listCodigoEppo.map(x => x.Id);
            //const selectedAll=Array.from(this.listCodigoEppo.values());
            this.form.patchValue({
                CodigoEppo: selectedAll,
            });
            //this.listCodigoEppo = especiesEppo.map(item => {
            //    const container: Tc = new Tc();
            //    container.Id = item.IdCodigoEppo;
            //    container.Descripcion = item.CodigoEppo;
            //    return container;
            //});
        }

        //para cuando es input en lugar de ng-select (quita la última coma)
        //if (cadenaEppo != '' && cadenaEppo[cadenaEppo.length - 2] == ',') {
        //    cadenaEppo = cadenaEppo.substr(0, cadenaEppo.length - 2)
        //}

        //this.listCodigoEppo = listGeneradaCodigosEppo.slice();
    }

    onSelectAgrupacionFechas(event: any): void {
        //this.IdAgrupacionFechas = event.value;

        switch (event.value) {
            case EnumIdsInformeInspeccionesAgrupacionFechas.ID_ANIO:
                this.IdAgrupacionFechasDescripcion = 'Año';

                //ordenación por defecto del grid de resultados
                this.OrderBy = 'Año';

                break;

            case EnumIdsInformeInspeccionesAgrupacionFechas.ID_MES:
                this.IdAgrupacionFechasDescripcion = 'Mes';

                //ordenación por defecto del grid de resultados
                this.OrderBy = 'AñoMes';

                break;

            default:
                this.IdAgrupacionFechasDescripcion = 'Sin agrupar';

                //ordenación por defecto del grid de resultados
                this.OrderBy = 'FechaEnvio';

                break;
        }
    }

    onSelectTipoSolicitud(event: Tc): void {
        if (event != undefined) {
            this.IdTipoSolicitudDescripcion = event.Descripcion;
        } else {
            this.IdTipoSolicitudDescripcion = '';
        }
    }

    onSelectEstadoSolicitud(event: Tc): void {
        if (event != undefined) {
            this.IdEstadoSolicitudDescripcion = event.Descripcion;
        } else {
            this.IdEstadoSolicitudDescripcion = '';
        }
    }

    onSelectPaisOrigen(event: Tc): void {
        if (event != undefined) {
            this.IdPaisOrigenDescripcion = event.Descripcion;
        } else {
            this.IdPaisOrigenDescripcion = '';
        }
    }

    onSelectPaisOrigenGrupoPaisFr(event: Tc): void {
        if (event != undefined) {
            this.IdPaisOrigenGrupoPaisFrDescripcion = event.Descripcion;
        } else {
            this.IdPaisOrigenGrupoPaisFrDescripcion = '';
        }
    }

    onSelectPaisProcedencia(event: Tc): void {
        if (event != undefined) {
            this.IdPaisProcedenciaDescripcion = event.Descripcion;
        } else {
            this.IdPaisProcedenciaDescripcion = '';
        }
    }

    onSelectIdPaisProcedenciaGrupoPaisFr(event: Tc): void {
        if (event != undefined) {
            this.IdPaisProcedenciaGrupoPaisFrDescripcion = event.Descripcion;
        } else {
            this.IdPaisProcedenciaGrupoPaisFrDescripcion = '';
        }
    }

    onSelectCodigoEppo(event: Tc[]): void {
        this.CodigoEppoDescripcionCollection = [];
        event.forEach(val => this.CodigoEppoDescripcionCollection.push(val.Descripcion));
    }

    onSelectProvincia(event: Tc): void {
        //limpiar descripciones de campos dependientes
        this.IdPuntoInspeccionDescripcion = '';

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            this.IdProvinciaDescripcion = event.Descripcion;

            this.form.controls['IdPuntoInspeccion'].enable();

            let params = new HttpParams();
            params = params.append('id', event.Id.toString());
            params = params.append('esimportacion', 'true');
            //cargar combos dependientes
            this.loadingPIFs = true;
            this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
                this.listPuntosInspeccion = res;
                this.loadingPIFs = false;
            });
        } else {
            //limpiar listas que alimentan los combos dependientes
            this.listPuntosInspeccion = [];

            //resetear selección de combos dependientes de éste
            this.form.patchValue({
                IdPuntoInspeccion: null,
            });
        }
    }

    onSelectPuntoInspeccion(event: Tc): void {
        if (event != undefined) {
            this.IdPuntoInspeccionDescripcion = event.Descripcion;
        } else {
            this.IdPuntoInspeccionDescripcion = '';
        }
    }

    onSelectMedida(event: Tc): void {
        if (this.form.value.IdMedida == null) {
            this.IdMedidaDescripcion = '';
        } else {
            this.IdMedidaDescripcion = event.Descripcion;
        }
    }

    onSelectMotivo(event: Tc): void {
        if (this.form.value.IdMotivo == null) {
            this.IdMotivoDescripcion = '';
        } else {
            this.IdMotivoDescripcion = event.Descripcion;
        }
    }

    onSelectDecision(event: Tc): void {
        if (this.form.value.IdDecision == null) {
            this.IdDecisionDescripcion = '';
        } else {
            this.IdDecisionDescripcion = event.Descripcion;
        }
    }

    onSelectSubForma(event: Tc): void {
        this.IdSubFormaDescripcion = '';

        if (event != undefined) {
            this.IdSubFormaDescripcion = event.Descripcion;
        } else {
            return;
        }
    }

    onCleanButton(): void {
        this.form.setValue({
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdAgrupacionFechas: EnumIdsInformeInspeccionesAgrupacionFechas.ID_SIN_AGRUPAR,
            IdTipoSolicitud: null,
            IdEstadoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            IdPaisOrigen: null,
            IdPaisOrigenGrupoPaisFr: null,
            IdPaisProcedencia: null,
            IdPaisProcedenciaGrupoPaisFr: null,
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            IdCriterioBusquedaProductos: this.form.controls['IdCriterioBusquedaProductos'].value, //'EPPO',
            CodigoTaric: '',
            CodigoEppo: null,
            IdDecision: null,
            IdMotivo: null,
            IdMedida: null,
        });

        this.IdAgrupacionFechasDescripcion = 'Sin agrupar';
        this.OrderBy = 'FechaEnvio';

        //se limpian los campos que guardan las descripciones que se asignan al modelo para viajar a servidor
        this.IdTipoSolicitudDescripcion = '';
        this.IdEstadoSolicitudDescripcion = '';
        this.IdProvinciaDescripcion = '';
        this.IdPuntoInspeccionDescripcion = '';
        this.IdPaisOrigenDescripcion = '';
        this.IdPaisOrigenGrupoPaisFrDescripcion = '';
        this.IdPaisProcedenciaDescripcion = '';
        this.IdPaisProcedenciaGrupoPaisFrDescripcion = '';
        this.IdDecisionDescripcion = '';
        this.IdMotivoDescripcion = '';
        this.IdMedidaDescripcion = '';

        this.IdGrupoDescripcion = '';
        this.IdFormaDescripcion = '';
        this.IdSubFormaDescripcion = '';
        this.CodigoEppoDescripcionCollection = [];

        this.listForma = [];
        this.listSubForma = [];
        this.listPuntosInspeccion = [];

        this.listCodigoEppo = []; //limpia el origen del combo de Código Eppo
        this.CodigoTaric = ''; //limpia el Código Taric

        //grupo y forma que se le pasa al popup de Código Eppo
        this.IdGrupo = null;
        this.IdForma = null;

        this.form.controls['IdPuntoInspeccion'].disable();

        this.onSelectCriterioBusquedaProductos();

        this.isCollapsed(false);

        this.searchingButton = false;

        this.resultInformeInspecciones = new InformeInspeccionesItemResultsViewModel();
    }

    isCollapsed(valor: boolean): void {
        this.isCollapsedGlobal =
            this.isCollapsedDatosSolicitud =
            this.isCollapsedLocalizacion =
            this.isCollapsedPaisOrigen =
            this.isCollapsedPaisProcedencia =
            this.isCollapsedProductos =
            this.isCollapsedInspeccion =
                valor;
    }

    onBack(): void {
        this.router.navigate(['/global/informes']);
    }

    onExportExcel(): void {
        let model: FilterSearchingInformeInspeccionesViewModel = this.CreateModel();

        //se cogen los criterios que haya
        model.OrderBy = this.OrderBy;
        model.Asc = this.OrderAsc;

        this.visibilitySpinner = true;
        this.informesService.exportInformeInspecciones(model).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultInformeInspecciones?.ResultList ? this.resultInformeInspecciones?.ResultList?.length > 0 : false;
    }
}
